import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../../config/firebase';
import { authService } from '../../utils/api/auth.service';
import { useAuth } from '../../context/AuthContext';
import { SEO } from '../../components/SEO/SEO';
import './Login.css';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await authService.login({ email, password });
      console.log('Login Success:', data);
      login(data.user || data); // Store user in context & localStorage
      alert('Logged in successfully!');
      navigate('/');
    } catch (error) {
      console.error('Login Error:', error.message);
      alert(error.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      console.log('Google Login Success:', user);
      
      const data = await authService.login({ email: user.email, password: user.email });
      // Merge backend data with Google photoURL
      const sessionUser = {
        ...(data.user || data),
        photoURL: user.photoURL
      };
      login(sessionUser);
      navigate('/');
    } catch (error) {
      console.error('Google Login Error:', error.message);
      alert('Google Login failed. Please try again.');
    }
  };

  return (
    <>
      <SEO 
        title="Login to Hobi Hub | Access Your Events & Bookings"
        description="Sign in to your Hobi Hub account to access your bookings, saved events, and personalized recommendations. Join the community of experience seekers."
        keywords="Hobi Hub login, sign in, account access, event bookings, user login"
        canonicalUrl="https://hobi.co.in/login"
      />
      <div className="login-page-container">
        {/* Left Side - Auth Form */}
        <div className="login-left">
          
          <div className="login-auth-content">
            <h1>Welcome Back!</h1>
            <p className="subtitle">Please enter log in details below</p>

          <form onSubmit={handleSubmit} className="login-form-new">
            <div className="login-input-container">
              <label>Email</label>
              <input 
                type="email" 
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="login-input-container">
              <label>Password</label>
              <div className="password-input-wrapper">
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  )}
                </button>
              </div>
            </div>


            <button type="submit" className="signin-button" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>

            <div className="login-divider-new">or continue</div>

            <button type="button" onClick={handleGoogleLogin} className="login-google-btn-new">
              <img src="/images/Google__G__logo.svg.png" alt="Google" className="login-google-icon-new" />
              Log in with Google
            </button>
          </form>

          <p className="login-signup-text">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>
        </div>
      </div>

      {/* Right Side - Branding/Image */}
      <div className="login-right">
        <div className="login-right-pattern" style={{ backgroundImage: "url('/images/homebg.svg')" }}></div>
        <Link to="/" className="login-logo-top">
          <img src="/images/hobi-white.svg" alt="Hobi Logo" />
        </Link>

          <div className="feature-image-wrapper">
           
            <img
              src="images/bg-edited.svg"
              loading="lazy"
              alt="Hobi - Go beyond routine, Find your flow"
            />
          </div>
         
          
      </div>
      </div>
    </>
  );
};
